import { GetWebReferenceSuffix } from "../functions/Configuration"

const iconQuestionRulesByWebRef: Record<string, Record<string, Record<string, string>>> = {
    RPO: {
        "PropertyType_ID": {
            "3MRG7BC3": "bungalow",
            "033": "house",
            "3MRG7BB7": "flat"
        },
        "ConversionType_ID": {
            "E3DA242D": "flat",
            "FD8393B1": "flat",
            "5F0CE88F": "conversion",
            "BEBFD10D": "conversion"
        },
        "FlatType_ID": {
            "2F6F6040": "flatbasement",
            "3824F0E6": "flatbasement",
            "DDC1BEB9": "firstfloorabove",
            "67AED345": "firstfloorabove",
            "87E4B67D": "groundfloor",
            "2F02BA49": "groundfloor"
        },
        "RequiredCover_ID": {
            "BC": "buildingandcontents",
            "BO": "buildingsonly",
            "CO": "contentsonly"
        },
        "AlarmType_ID": {
            "10": "bellonly",
            "3": "centralstation",
            "80E85B74": "police",
            "4BE6FFCA": "police",
            "646F3166": "phone",
            "1163C5FC": "phone"
        },
        "SafeType_ID": {
            "1": "floorsafe",
            "43F66B1E": "anchored",
            "70BCA326": "anchored",
            "3": "freestand",
            "2": "wall",
        }
    }
};

const nativeSelectRulesByWebRef: Record<string, Record<string, string[]>> = {
    RPO: {
        HouseType_ID: ["5037360B", "5201D0F1", "EEB369CE", "F811AE46", "E1933A59", "524848E9"],
        TypeOfBungalow_ID: ["B00B233D", "9ED0302F", "F1AFB2FE", "9F65B980", "DEE811BC", "0C00F431", "F106599D", "ACF1DAD3"],
        FlatRoofConstrn_ID: ["81695D7F", "30DDA036", "3BE5A30D"],
        WallConstructn_ID: ["02", "BRICKTIM", "05", "77C8D0C7", "STEELFRA", "18"],
        RoofConstructn_ID: ["02"],
        OutbldgWallCons_ID: ["02", "BRICKTIM", "05", "77C8D0C7", "77C8D0C7", "18"],
        OutbldgRoofCons_ID: ["02"],
    }
};

export function getNativeSelectRenderData(question: any) {
    const rawOptions = question?.answerList ?? [];
    const radioValues = getNativeSelectRadioValues(question);

    const baseRadioOptions = rawOptions.filter((opt: any) =>
        radioValues.includes(opt.value)
    );

    const dropdownOptions = rawOptions.filter((opt: any) =>
        !radioValues.includes(opt.value)
    );

    const currentAnswer =
        question.answer ??
        rawOptions.find((opt: any) => opt.selected)?.value;

    const isOtherSelected =
        currentAnswer === NATIVE_SELECT_OTHER_VALUE ||
        (!!currentAnswer && !radioValues.includes(currentAnswer));

    const radioOptions = [
        ...baseRadioOptions.map((opt: any) => ({
            ...opt,
            selected: currentAnswer === opt.value
        })),
        {
            text: "Other",
            value: NATIVE_SELECT_OTHER_VALUE,
            selected: isOtherSelected
        }
    ];

    return {
        radioValues,
        baseRadioOptions,
        dropdownOptions,
        currentAnswer,
        isOtherSelected,
        radioOptions
    };
}

export const NATIVE_SELECT_OTHER_VALUE = "__OTHER__";

export function isIconOptions(question: any) {
    const webRefSuffix = GetWebReferenceSuffix(getWebReference());
    const answerFieldName = question.questionSetQuestion.answerFieldName;

    return !!iconQuestionRulesByWebRef[webRefSuffix]?.[answerFieldName];
}

export function decorateOptionsWithIcons(question: any, answerList: any[]) {
    const webRefSuffix = GetWebReferenceSuffix(getWebReference());
    const answerFieldName = question.questionSetQuestion.answerFieldName;

    const rules: Record<string, string> | undefined =
        iconQuestionRulesByWebRef[webRefSuffix]?.[answerFieldName];

    if (!rules) return answerList;

    return answerList.map((opt: any) => {
        const value = String(opt.value);
        const iconName = rules[value];

        if (!iconName) return opt;

        return {
            ...opt,
            iconSrc: require(`../assets/questionIcons/${iconName}.png`),
            iconAlt: iconName,
        };
    });
}

export function getWebReference(): string {
    return localStorage.getItem("webReference") || "";
}

export function isNativeSelectSplit(question: any): boolean {
    const webRefSuffix = GetWebReferenceSuffix(getWebReference());
    const answerFieldName = question.questionSetQuestion.answerFieldName;

    return !!nativeSelectRulesByWebRef[webRefSuffix]?.[answerFieldName];
}

export function getNativeSelectRadioValues(question: any): string[] {
    const webRefSuffix = GetWebReferenceSuffix(getWebReference());
    const answerFieldName = question.questionSetQuestion.answerFieldName;

    return nativeSelectRulesByWebRef[webRefSuffix]?.[answerFieldName] ?? [];
}